var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCharging = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "charging_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  mask: "url(#charging_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.627 4.667h-18.33l-3.388 9.757V26.97h4.182v-2.788h16.727v2.788H33V14.424l-3.373-9.757ZM12.787 20a2.088 2.088 0 0 1-2.09-2.09c0-1.158.934-2.092 2.09-2.092 1.158 0 2.092.934 2.092 2.091S13.945 20 12.788 20Zm15.334 0a2.088 2.088 0 0 1-2.09-2.09c0-1.158.933-2.092 2.09-2.092 1.157 0 2.091.934 2.091 2.091S29.278 20 28.122 20Zm-17.424-6.97 2.09-6.272h15.334l2.091 6.272H10.697ZM13.485 31.151h5.576v-2.787l8.363 4.181H21.85v2.788l-8.364-4.181Z"
}))));
export default SvgCharging;